<div class="fu-list-container" (click)="selectFU()">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-fcu-selected-fcu-fu-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.fu.title" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="more-info-status" />
        </div>
    </div>
</div>
